import React from 'react';

const ROWS = [
  {
    session: '1',
    subject: '🚀 Introduction & MI-LXC',
    duration: '3h',
    description:
      'Présentation du module, enjeux cybersécurité, prise en main MI-LXC'
  },
  {
    session: '2',
    subject: '🎯 ARP Spoofing',
    duration: '3h'
  },
  {
    session: '3',
    subject: '🔒 HTTPS & Reverse Proxy',
    duration: '4h'
  },
  {
    session: '4',
    subject: '🔥 Firewall Linux (iptables)',
    duration: '4h'
  },
  {
    session: '5',
    subject: '🛡️ pfSense Firewall',
    duration: '4h'
  },
  {
    session: '6',
    subject: '🌐 DNS',
    duration: '4h'
  },
  {
    session: '7',
    subject: '🔍 TP Forensic',
    duration: '4h'
  },
  {
    session: '8',
    subject: '📝 Évaluation',
    duration: '1h'
  }
];

export default function Planning() {
  const styles = {
    container: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '10px'
    },
    title: {
      color: '#4ecdc4',
      fontSize: '2em',
      textAlign: 'center',
      marginBottom: '20px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
    },
    sessionCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '10px',
      padding: '12px',
      margin: '8px 0',
      border: '2px solid rgba(78, 205, 196, 0.3)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      transition: 'all 0.3s ease'
    },
    sessionHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '5px'
    },
    sessionNumber: {
      backgroundColor: '#4ecdc4',
      color: 'white',
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      minWidth: '60px',
      minHeight: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px',
      fontWeight: 'bold',
      flexShrink: 0,
      marginRight: '15px'
    },
    sessionTitle: {
      color: '#4ecdc4',
      fontSize: '1.1em',
      fontWeight: 'bold',
      flex: 1
    },
    sessionDuration: {
      backgroundColor: '#ff6b6b',
      color: 'white',
      padding: '6px 12px',
      borderRadius: '15px',
      fontSize: '1em',
      fontWeight: 'bold',
      flexShrink: 0
    },
    sessionDescription: {
      color: 'white',
      fontSize: '0.85em',
      lineHeight: '1.3',
      marginTop: '5px',
      fontStyle: 'italic'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        Planning{' '}
        <span role="img" aria-label="Calendar">
          📅
        </span>
      </h1>

      {ROWS.map(({ session, subject, duration, description }, idx) => (
        <div key={idx} style={styles.sessionCard}>
          <div style={styles.sessionHeader}>
            <div style={styles.sessionNumber}>{session}</div>
            <div style={styles.sessionTitle}>{subject}</div>
            <div style={styles.sessionDuration}>{duration}</div>
          </div>
          {description && (
            <div style={styles.sessionDescription}>{description}</div>
          )}
        </div>
      ))}
    </div>
  );
}
